import { JSX, PropsWithChildren } from 'react';
import { AppContext } from '../../config';
import { AppContextModel } from '../../model/AppContext.model';

type Props = AppContextModel & PropsWithChildren;

export const AppContextProvider = ({
                                     children,
                                     showAlert,
                                     setLoaderVisibility,
                                     showConfirmationDialog,
                                     setBusinessContext,
                                     businessContext,
                                     customerId,
                                     setCustomerId
                                   }: Props): JSX.Element => {
  return <AppContext.Provider value={{
    setLoaderVisibility,
    showAlert,
    showConfirmationDialog,
    setBusinessContext,
    businessContext,
    customerId,
    setCustomerId
  }}>{children}</AppContext.Provider>;
};
